import React from "react";
import { OverviewCardProps } from "./types";

export const OverviewCard: React.FC<OverviewCardProps> = ({
  children,
  className = "",
  hoverable = false,
  onClick,
  variant = "default",
  style,
}) => {
  const classNames = [
    "ao-card",
    hoverable ? "hoverable" : "",
    variant !== "default" ? `variant-${variant}` : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classNames} onClick={onClick} style={style}>
      {children}
    </div>
  );
};
